export default __webpack_public_path__ + "static/media/apple-touch-icon.455eb884.png";